import { render, staticRenderFns } from "./policy-holder-info.vue?vue&type=template&id=11a13c0c&scoped=true&"
import script from "./policy-holder-info.vue?vue&type=script&lang=js&"
export * from "./policy-holder-info.vue?vue&type=script&lang=js&"
import style0 from "./policy-holder-info.vue?vue&type=style&index=0&id=11a13c0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a13c0c",
  null
  
)

export default component.exports